/* eslint-disable react/no-unknown-property */

import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function Infos({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g fill={color}>
        <path d="m12.675 16.5h-1.35v-6h1.35z" />
        <path d="m12 7.50005c.4971 0 .9.40294.9.9 0 .49705-.4029.9-.9.9-.497 0-.9-.40295-.9-.9 0-.49706.403-.9.9-.9z" />
        <path clip-rule="evenodd" d="m12 1.80005c5.6334 0 10.2 4.56669 10.2 10.19995 0 5.6334-4.5666 10.2-10.2 10.2-5.63326 0-10.19995-4.5666-10.19995-10.2 0-5.63326 4.56669-10.19995 10.19995-10.19995zm0 1.35c-4.88767 0-8.84995 3.96228-8.84995 8.84995 0 4.8878 3.96228 8.85 8.84995 8.85 4.8878 0 8.85-3.9622 8.85-8.85 0-4.88767-3.9622-8.84995-8.85-8.84995z" fill-rule="evenodd" />
      </g>
    </SVGWrapper>
  );
}

export default Infos;
